import { c as _c } from "react/compiler-runtime";
import { LinkList, LinkListItem } from '@petsmart-ui/sparky';
import { usePathname, useRouter } from 'next/navigation';
import type { MenuItem } from '@/types';
type SidebarItemProps = {
  item: MenuItem;
  handleClose?: () => void;
};
export function SidebarItem(t0) {
  const $ = _c(20);
  const {
    item,
    handleClose
  } = t0;
  const pathname = usePathname() as string;
  const router = useRouter();
  let t1;
  if ($[0] !== handleClose || $[1] !== router) {
    t1 = (path, queryParams) => {
      const href = queryParams ? `${path}?${new URLSearchParams(queryParams).toString()}` : path;
      router.push(href);
      if (handleClose) {
        handleClose();
      }
    };
    $[0] = handleClose;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleNavigation = t1;
  if ("items" in item) {
    let t2;
    if ($[3] !== item.title) {
      t2 = <div className="sidebar__section-title">{item.title}</div>;
      $[3] = item.title;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== item.items) {
      t3 = item.items.map(_temp);
      $[5] = item.items;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== t3) {
      t4 = <LinkList>{t3}</LinkList>;
      $[7] = t3;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== t2 || $[10] !== t4) {
      t5 = <div className="sidebar__section">{t2}{t4}</div>;
      $[9] = t2;
      $[10] = t4;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  const isActive = item.path === "/" ? pathname === "/" : pathname.startsWith(item.path);
  const t2 = isActive ? "active" : "";
  let t3;
  if ($[12] !== handleNavigation || $[13] !== item.path || $[14] !== item.queryParams) {
    t3 = () => handleNavigation(item.path, item.queryParams);
    $[12] = handleNavigation;
    $[13] = item.path;
    $[14] = item.queryParams;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== item.title || $[17] !== t2 || $[18] !== t3) {
    t4 = <LinkListItem text={item.title} className={t2} onClick={t3} />;
    $[16] = item.title;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
}
function _temp(subItem) {
  return <SidebarItem key={subItem.title} item={subItem} />;
}